/** Query destinations match their own parameters; nested detail paths are explicit. */
export function navDestinationIsSelected(currentPath: string, destination: string, activePaths: readonly string[] = []) {
  const [currentPathname, currentQuery = ''] = currentPath.split('?');
  if (activePaths.some(path => currentPathname!.startsWith(path))) return true;
  const [destinationPathname, destinationQuery = ''] = destination.split('?');
  if (currentPathname !== destinationPathname) return false;
  const destinationParams = new URLSearchParams(destinationQuery);
  const currentParams = new URLSearchParams(currentQuery);
  if (destinationParams.get('view') === 'all' && !currentParams.has('view')) return true;
  return [...destinationParams.entries()].every(([key, value]) => currentParams.get(key) === value);
}

/** Resolve against current permissions, never the item captured when a menu opened. */
export function currentNavMenu<T extends { path: string }>(items: readonly T[], selected: { path: string } | null) {
  return items.find(item => item.path === selected?.path) ?? null;
}
